<template>
  <div class="gm-step gm-step6">
    <section class="gs-wizard-card">
      <h2>When should it go out?</h2>
      <p>Send it right away, pick a date and time, or keep it as a draft for now.</p>
      <div class="gm-choice-grid gm-step6__options">
        <div
          v-if="broadcastSendingAllowed()"
          class="gm-choice-card"
          :class="{
            'is-selected': localModel.emailscheduled === 'sendnow',
            'is-disabled': !localModel.filledemails || localModel.filledemails === 0,
          }"
          role="radio"
          :aria-checked="localModel.emailscheduled === 'sendnow' ? 'true' : 'false'"
          tabindex="0"
          :title="
            !localModel.filledemails || localModel.filledemails === 0
              ? $t('frontend_groovemail_campaign_no_recipients_selected')
              : ''
          "
          @click="localModel.filledemails ? showtab('sendnow') : null"
          @keydown.enter.prevent="localModel.filledemails ? showtab('sendnow') : null"
          @keydown.space.prevent="localModel.filledemails ? showtab('sendnow') : null"
        >
          <span class="gm-choice-card__radio" aria-hidden="true"></span>
          <PaperIcon class="gm-choice-card__icon"/>
          <strong class="gm-choice-card__title">{{ $t('frontend_groovemail_campains_step6_send_now') }}</strong>
          <span class="gm-choice-card__desc">{{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_send_now_desc') }}</span>
        </div>
        <div
          v-if="broadcastSendingAllowed()"
          class="gm-choice-card"
          :class="{
            'is-selected': localModel.emailscheduled === 'sendlater',
            'is-disabled': !localModel.filledemails || localModel.filledemails === 0,
          }"
          role="radio"
          :aria-checked="localModel.emailscheduled === 'sendlater' ? 'true' : 'false'"
          tabindex="0"
          :title="
            !localModel.filledemails || localModel.filledemails === 0
              ? $t('frontend_groovemail_campaign_no_recipients_selected')
              : ''
          "
          @click="localModel.filledemails ? showtab('sendlater') : null"
          @keydown.enter.prevent="localModel.filledemails ? showtab('sendlater') : null"
          @keydown.space.prevent="localModel.filledemails ? showtab('sendlater') : null"
        >
          <span class="gm-choice-card__radio" aria-hidden="true"></span>
          <ScheduleIcon class="gm-choice-card__icon"/>
          <strong class="gm-choice-card__title">{{ $t('frontend_groovemail_campains_step6_schedule_for') }}</strong>
          <span class="gm-choice-card__desc">{{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_schedule_later') }}</span>
        </div>
        <div
          class="gm-choice-card"
          :class="{ 'is-selected': localModel.emailscheduled === 'savedraft' }"
          role="radio"
          :aria-checked="localModel.emailscheduled === 'savedraft' ? 'true' : 'false'"
          tabindex="0"
          @click="showtab('savedraft')"
          @keydown.enter.prevent="showtab('savedraft')"
          @keydown.space.prevent="showtab('savedraft')"
        >
          <span class="gm-choice-card__radio" aria-hidden="true"></span>
          <DraftIcon class="gm-choice-card__icon"/>
          <strong class="gm-choice-card__title">{{ $t('frontend_groovemail_campains_step6_save_as_draft') }}</strong>
          <span class="gm-choice-card__desc">{{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_draft') }}</span>
        </div>
      </div>

      <div class="gm-step6__schedule" v-if="localModel.emailscheduled === 'sendlater'">
        <gs-field
          :label="$t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_chosse_date_time')"
        >
          <div class="gm-step6__picker">
            <DateTimePicker
              v-model="localModel.sheduledtime"
              variant="base"
              :picker="'datetime'"
              :timeZone="'UTC'"
              :zone="'America/New_York'"
              :minDatetime="minDateForSchedule"
            />
            <CalenderIcon class="gm-step6__picker-icon"/>
          </div>
        </gs-field>
        <p class="gm-step6__timezone" role="note">
          {{ $t('frontend_groovemail_all_emails_to_be_scheduled_in_est_timezone') }}
        </p>
      </div>
    </section>

    <section class="gs-wizard-card gm-review-card">
      <header class="gm-review-card__head">
        <span class="gm-review-card__check" aria-hidden="true">
          <gs-icon name="check" size="14"></gs-icon>
        </span>
        <h2>{{ $t('frontend_groovemail_campaign_detail_route_page_title') }}</h2>
        <gs-button
          variant="outline"
          size="sm"
          @click="switchToThisStep('step1')"
        >{{ $t('frontend_edit') }}</gs-button>
      </header>
      <div class="gm-review-card__body">
        <span class="gm-review-card__label">{{ $t('frontend_groovemail_campaign_name') }}</span>
        <p class="gm-review-card__value">
          {{ localModel.name }}
          <span class="gm-review-card__pill">{{ localModel.sendoption }}</span>
        </p>
      </div>
    </section>

    <section class="gs-wizard-card gm-review-card">
      <header class="gm-review-card__head">
        <span class="gm-review-card__check" aria-hidden="true">
          <gs-icon name="check" size="14"></gs-icon>
        </span>
        <h2>
          {{ $t('frontend_groovemail_lists_route_page_title') }},
          {{ $t('frontend_groovemail_tags_route_page_title') }} &amp;
          {{ $t('frontend_groovemail_segment_route_page_title') }}
        </h2>
        <gs-button
          variant="outline"
          size="sm"
          @click="switchToThisStep('step3')"
        >{{ $t('frontend_edit') }}</gs-button>
      </header>
      <div class="gm-review-card__body">
        <p class="gm-review-card__value">
          {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_send_campaign_header') }}
          <span>{{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_new_subscribers_header') }}.</span>
        </p>
        <p
          class="gm-review-card__value"
          v-if="
            0 < localModel.remainingEmails ||
            localModel.remainingEmails === -1
          "
        >
          {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_estimated_header') }}
          <strong>
            {{
              localModel.filledemails >= localModel.remainingEmails &&
              localModel.remainingEmails !== -1
                ? localModel.remainingEmails
                : localModel.filledemails
            }}
          </strong>
          {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_total_recipients_header') }}.
        </p>
        <p class="gm-review-card__value gm-review-card__value--danger" v-else>
          {{ $t('frontend_groovemail_segment_subscribe_remaining_count_less_message') }}
        </p>
      </div>
    </section>

    <section class="gs-wizard-card gm-review-card" v-if="localModel.sendoption !== 'postal'">
      <header class="gm-review-card__head">
        <span class="gm-review-card__check" aria-hidden="true">
          <gs-icon name="check" size="14"></gs-icon>
        </span>
        <h2>{{ $t('frontend_groovemail_forms_step2_double_optin_sender_info') }}</h2>
        <gs-button
          variant="outline"
          size="sm"
          @click="switchToThisStep('step4')"
        >{{ $t('frontend_edit') }}</gs-button>
      </header>
      <div class="gm-review-card__body">
        <p class="gm-review-card__value">
          {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_mail_sent_from_header') }}
          <strong>{{ localModel.sendername }}.</strong>
        </p>
        <p class="gm-review-card__value gm-review-card__value--muted">
          &lt; {{ localModel.senderemail }} &gt;
        </p>
      </div>
    </section>

    <section class="gs-wizard-card gm-review-card" v-if="localModel.sendoption !== 'postal'">
      <header class="gm-review-card__head">
        <span class="gm-review-card__check" aria-hidden="true">
          <gs-icon name="check" size="14"></gs-icon>
        </span>
        <h2>{{ $t('frontend_groovemail_campains_step4_message_content') }}</h2>
        <gs-button
          variant="outline"
          size="sm"
          @click="switchToThisStep('step4')"
        >{{ $t('frontend_edit') }}</gs-button>
      </header>
      <div class="gm-review-card__body">
        <p
          class="gm-review-card__value"
          v-if="localModel.sendoption === 'email'"
        >
          {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_subject_line_header') }}: <strong>{{ localModel.emailsubject }}</strong>
        </p>
        <div class="gm-step6__preview">
          <campaign-preview
            v-if="localModel.sendoption == 'sms'"
            :campaignMethod="localModel.sendoption"
            :campaignMessage="localModel.smscontent"
          ></campaign-preview>
          <div class="gm-step6__preview-frame" v-if="localModel.sendoption == 'email'">
            <div v-shadow>
              <div
                class="pb-6"
                v-html="
                  localModel.emailcontent +
                  `<p style='margin: 0px'><br></p>` +
                  unsubscribeContent
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import DateTimePicker from '@groovepages/gd-ui-kit/components/DateTimePicker';
import themeConfig from '@/theme/themeConfig.js';

// import icons
import CheckmarkIcon from '@/assets/images/icons/new/checkmark_new.svg';
import PaperIcon from '@/assets/images/icons/new/paper_new.svg';
import ScheduleIcon from '@/assets/images/icons/new/schedule_new.svg';
import DraftIcon from '@/assets/images/icons/new/draft_new.svg';
import CalenderIcon from '@/assets/images/icons/new/calendar_days_new.svg';

import CampaignPreview from './campaign-preview.vue';
import { userBroadcastSendRestriction } from '@/components/user-plan-limit/checkUserEmailSendLimit.js';

export default {
  name: 'step6',
  props: {
    model: {
      required: true,
    },
  },
  data() {
    return {
      changesMadeInStep: false,
      localModel: this.model,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      unsubscribeContent: '',
      broadcastRestrictions: {
        can_sent_broadcast: 1,
        can_sent_broadcast_at: null,
        can_use_broadcast: 1,
        can_use_broadcast_at: null,
      },
    };
  },

  async created() {
    // show loader
    this.showLoader();

    try {
      await this.updateBroadcastRestirctions();
      let sendersData;
      if (this.localModel.sendoption === 'email') {
        const { data } = await axios.get('/sender');
        if (data.length > 0) {
          sendersData = data;
          sendersData.forEach((element) => {
            if (element.id === this.localModel.sender_id) {
              this.localModel.sendername = element.sender_name;
              this.localModel.senderemail = element.sender_email;
            }
          });
        }
        const unsubscribeData = await axios.get('/setting/get-unsubscribe-layout');
        this.unsubscribeContent = unsubscribeData.data.footer_layout;
      } else if (this.localModel.sendoption === 'sms') {
        const integrationData = await axios.get('/sms-sender');
        if (
          integrationData &&
          integrationData.data &&
          integrationData.data.length
        ) {
          sendersData = integrationData.data;
          sendersData.forEach((element) => {
            if (element.id === this.localModel.sender_id) {
              this.localModel.sendername = element.gateway_name;
              this.localModel.senderemail = `${element.country_code} ${element.from_number}`;
            }
          });
        }
      }
    } catch (error) {
      // show error
      this.$emit('requestErrorAlert', error.response?.data?.error);

      return;
    }

    if (!this.localModel.filledemails || this.localModel.filledemails === 0) {
      this.localModel.emailscheduled = 'savedraft';
      this.localModel.sheduledtime = new Date().toISOString();
    }
    this.hideLoader();
  },

  methods: {
    ...mapGetters('mailing', ['getCanMail']),

    checkChangesMadeOnThisStep() {
      return this.changesMadeInStep;
    },

    switchToThisStep(step) {
      this.$emit('switchToThisStep', step);
    },

    showtab(value) {
      this.localModel.emailscheduled = value;
      if (value === 'savedraft' || value === 'sendnow') {
        this.localModel.sheduledtime = new Date().toISOString();
      }
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    broadcastSendingAllowed() {
      // send option email validation
      const emailValid = this.localModel.sendoption === 'email' &&
          this.userCanMail !== 0 &&
          this.localModel.sender_id &&
          this.localModel.sender_id !== -1 &&
          this.localModel.emailcontent &&
          this.localModel.emailsubject;

      // send option sms validation
      const smsValid = this.localModel.sendoption === 'sms' &&
          this.userCanMail !== 0 &&
          this.localModel.sender_id &&
          this.localModel.sender_id !== -1 &&
          this.localModel.smscontent;

      // send option postal validation
      const postalValid = this.localModel.sendoption === 'postal' &&
          this.localModel.postal_sequence_id;

      return (emailValid || smsValid || postalValid);
    },

    async updateBroadcastRestirctions() {
      try {
        this.broadcastRestrictions = await userBroadcastSendRestriction(this.model.sendoption);
      } catch (error) {
        // show error
        this.$emit('requestErrorAlert', error.response?.data?.error);

        return;
      }

      if (
        !this.broadcastRestrictions.can_use_broadcast &&
        new Date(this.localModel.sheduledtime) <
          new Date(this.broadcastRestrictions.can_use_broadcast_at)
      ) {
        this.localModel.sheduledtime = moment
          .utc(this.broadcastRestrictions.can_use_broadcast_at)
          .toISOString();
      } else if (
        !this.broadcastRestrictions.can_sent_broadcast &&
        new Date(this.localModel.sheduledtime) <
          new Date(this.broadcastRestrictions.can_sent_broadcast_at)
      ) {
        this.localModel.sheduledtime = moment
          .utc(this.broadcastRestrictions.can_sent_broadcast_at)
          .toISOString();
      }
    },
  },

  components: {
    VuePerfectScrollbar,
    DateTimePicker,
    CheckmarkIcon,
    PaperIcon,
    ScheduleIcon,
    DraftIcon,
    CalenderIcon,
    CampaignPreview,
  },

  computed: {
    userCanMail() {
      return this.getCanMail();
    },

    minDateForSchedule() {
      if (!this.broadcastRestrictions.can_use_broadcast) {
        return new Date(
          this.broadcastRestrictions.can_use_broadcast_at
        ).toISOString();
      }
      if (!this.broadcastRestrictions.can_sent_broadcast) {
        return new Date(
          this.broadcastRestrictions.can_sent_broadcast_at
        ).toISOString();
      }
      return new Date().toISOString();
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'localModel.emailscheduled': function updateEmailScheduledChanges() {
      this.changesMadeInStep = true;
    },

    'localModel.sheduledtime': function updateScheduledTimeChanges() {
      this.changesMadeInStep = true;
    },
  },
};
</script>

<style>
.gm-campaign-create .gm-step6__options {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.gm-campaign-create .gm-step6__schedule {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid var(--gs-border);
}

.gm-campaign-create .gm-step6__picker {
  position: relative;
  max-width: 380px;
}

.gm-campaign-create .gm-step6__picker-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 2;
  width: 18px;
  height: 18px;
  color: var(--gs-muted-foreground);
  pointer-events: none;
  transform: translateY(-50%);
}

.gm-campaign-create .gm-step6__picker .border {
  border-color: var(--gs-border);
  border-radius: var(--gs-radius-sm);
}

/* Timezone caution: a warning, not help text (no --gs-warning token yet). */
.gm-campaign-create .gm-step6__timezone {
  margin: 10px 0 0;
  color: var(--gs-danger);
  font-size: 13px;
  font-weight: 600;
}

/* Review cards */
.gm-campaign-create .gm-review-card__head {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.gm-campaign-create .gm-review-card__head h2 {
  margin: 0;
  min-width: 0;
}

.gm-campaign-create .gm-review-card__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--gs-success);
  background: var(--gs-success-soft);
  border: 1px solid var(--gs-success-border);
  border-radius: 999px;
}

.gm-campaign-create .gm-review-card__body {
  padding-left: 40px;
}

.gm-campaign-create .gm-review-card__label {
  display: block;
  margin-bottom: 4px;
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.gm-campaign-create .gm-review-card__value {
  margin: 0 0 6px;
  color: var(--gs-foreground);
  font-size: 14px;
  line-height: 1.55;
}

.gm-campaign-create .gm-review-card__value:last-child {
  margin-bottom: 0;
}

.gm-campaign-create .gm-review-card__value strong {
  font-weight: 700;
}

.gm-campaign-create .gm-review-card__value--muted {
  color: var(--gs-muted-foreground);
}

.gm-campaign-create .gm-review-card__value--danger {
  color: var(--gs-danger);
}

.gm-campaign-create .gm-review-card__pill {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  margin-left: 6px;
  padding: 2px 8px;
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  background: var(--gs-muted);
  border: 1px solid var(--gs-border);
  border-radius: 999px;
}

.gm-campaign-create .gm-step6__preview {
  margin-top: 12px;
}

.gm-campaign-create .gm-step6__preview-frame {
  max-height: 560px;
  padding: 16px;
  overflow: auto;
  background: var(--gs-surface-subtle);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-sm);
}

@media (max-width: 640px) {
  .gm-campaign-create .gm-review-card__body {
    padding-left: 0;
  }
}
</style>
